const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

export function encodeBits(bits: readonly boolean[]): string {
  const bytes = new Uint8Array(Math.ceil(bits.length / 8));
  bits.forEach((value, index) => {
    if (value) bytes[Math.floor(index / 8)]! |= 1 << (index % 8);
  });

  let result = "";
  for (let index = 0; index < bytes.length; index += 3) {
    const a = bytes[index] ?? 0;
    const b = bytes[index + 1] ?? 0;
    const c = bytes[index + 2] ?? 0;
    const packed = (a << 16) | (b << 8) | c;
    result += alphabet[(packed >> 18) & 63];
    result += alphabet[(packed >> 12) & 63];
    result += index + 1 < bytes.length ? alphabet[(packed >> 6) & 63] : "=";
    result += index + 2 < bytes.length ? alphabet[packed & 63] : "=";
  }
  return result;
}

function decodeByte(mask: string, byteIndex: number): number {
  const groupStart = Math.floor(byteIndex / 3) * 4;
  const a = alphabet.indexOf(mask[groupStart] ?? "A");
  const b = alphabet.indexOf(mask[groupStart + 1] ?? "A");
  const c = Math.max(0, alphabet.indexOf(mask[groupStart + 2] ?? "A"));
  const d = Math.max(0, alphabet.indexOf(mask[groupStart + 3] ?? "A"));
  const packed = (a << 18) | (b << 12) | (c << 6) | d;
  return (packed >> (16 - (byteIndex % 3) * 8)) & 0xff;
}

export function bitAt(mask: string | undefined, index: number): boolean {
  if (!mask || index < 0) return false;
  const byte = decodeByte(mask, Math.floor(index / 8));
  return (byte & (1 << (index % 8))) !== 0;
}
